var styles = {"socialLink":"SocialLinks-module_socialLink__XdR0g","noSvg":"SocialLinks-module_noSvg__y5sSK"};

export { styles as default };
//# sourceMappingURL=SocialLinks.module.scss.js.map
